<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a>
      </v-col>
      <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;" class="">
        <v-row class="signup-form overflow-hidden mx-1 mb-1" style="">
          <v-card-title class="font-weight-black">パスワード再設定メールを送る</v-card-title>
          <p style="color: #9E9EA7;" class="">パスワードを変更したいユーザーのユーザーコードを入力してください。</p>
          <v-card-text class="pa-5 pt-0">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <v-row>
                <v-col cols=12>
                  <ValidationProvider name="ユーザコード" rules="required|min:8|max:15|userCodeRegex" v-slot="{ errors }">
                    <v-text-field
                        label="ユーザコード"
                        v-model="user.user_code"
                        :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols=12 class="text-center">
                  <v-btn
                      @click="postPasswordResetToken"
                      color="primary"
                      class="button-shadow ma-4"
                      width="50%"
                      type="submit"
                      :disabled="invalid"
                  >送信</v-btn>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-card-text>
          <v-col cols=12>
            <v-row style="padding-top: 0; padding-bottom: 0;" align="center" justify="end" class="">
              <a href="/" class="btn-primary" style="font-size: 14px; text-decoration: none;">ホームに戻る</a>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      user : {
        user_code: '',
      },
      height: window.innerHeight,
    };
  },
  methods: {
    postPasswordResetToken() {
      this.$store.dispatch('passwordReset/post', this.user)
        .then(() => {
          this.$swal({
            title: "ご登録いただいたメールアドレス宛に確認メールをお送りしております。ご確認ください。",
            icon: require("@/assets/vla_tips_logo_mini.png"),
          });
          this.$router.push('/login')
        })
    },
  },
}
</script>